import Stack from '@/components/Custom/ModalStack';

export default function PrivateTeamCreateLayoutRoute() {
  return <Stack />;
}
